import { React, useContext, useEffect, useState } from 'react'
import { Button, Icon, Table, Pagination, Form } from 'semantic-ui-react'
import { DebounceInput } from 'react-debounce-input'
import { useSelector } from 'react-redux'
import { AlertViewContext } from '../alert-info-view/alertView'
import classes from './deviceList.module.css'
import IntelMsg from '../../../ItelMsg'
import styles from '../../device/device-info-view/device-view.module.css'
import {
  GetPaginationDevicesList,
  GetAllDeviceInfo,
} from '../../../../services/device-page-list'
import { history, store } from '../../../../redux/store'
import { primaryColor } from '../../../../constants'
import { GetAllCustomers } from '../../../../services/customer'
import { GetCustomerDevices } from '../../../../services/asset'
import StatusDialog from '../../../status-dialog'
import { setDeviceData } from '../../../../redux/actions/deviceData'

const { dispatch } = store

const DeviceList = () => {
  const { userEmail } = useSelector((storet) => ({
    userEmail: storet.auth.userEmail,
  }))
  const productName = localStorage.getItem('product')
  const [assetList, setAssetList] = useState([])
  const [customersList, setCustomersList] = useState([])
  const [noOfPages, setNoOfPages] = useState(0)
  const [showStatusDialog, setShowStatusDialog] = useState(false)
  const [dialogContent, setDialogContent] = useState(<></>)
  const [searchTerm, setSearchTerm] = useState('')
  const [searchCriteria, setSearchCriteria] = useState('id')
  const [searchStatus, setSearchStatus] = useState('INSTALLED')
  const [searchName, setSearchName] = useState('')
  const [customer, setCustomer] = useState('all')
  const [searchId, setSearchId] = useState('')
  const [pageSize] = useState(10)
  const { setViewAlert, setAssetData, viewAlert } = useContext(AlertViewContext)
  const [activePage, setActivePage] = useState(0)
  const [selectState, setSelectState] = useState('all,all')

  const criteria = [
    { key: 1, text: 'ID', value: 'id' },
    { key: 2, text: 'Name', value: 'name' },
    { key: 3, text: 'Status', value: 'status' },
  ]

  const status = [
    { key: 1, text: 'Offline', value: 'OFFLINE' },
    { key: 2, text: 'Connected', value: 'CONNECTED' },
    { key: 3, text: 'Installed', value: 'INSTALLED' },
    { key: 4, text: 'Configured', value: 'CONFIGURED' },
  ]

  const handleChange = (event) => {
    setSearchTerm(event.target.value)
  }

  const handleSaveCustomerSelect = (e) => {
    const customerDetails = JSON.parse(e)
    setSelectState(
      `${customerDetails.c_id},${customerDetails.c_name},${customerDetails.c_email},${customerDetails.c_tenant}`,
    )
    setCustomer(customerDetails.c_id)
    console.log(customerDetails.c_id, customerDetails.c_name)
    if (customerDetails.c_name !== 'none') {
      GetCustomerDevices(
        customerDetails.c_email,
        localStorage.getItem('product'),
        activePage,
        pageSize,
        customerDetails.c_id,
      ).then((_data) => {
        setActivePage(0)
        setAssetList(_data.data)
        setNoOfPages(_data['no of pages'])
      })
    }
  }

  const handleSelect = (e) => {
    setSearchCriteria(e.target.outerText.toLocaleLowerCase())
    setSearchTerm(searchTerm)
    setSearchName(searchTerm)
    setSearchId(searchTerm)
    setSearchStatus(searchTerm)
    if (
      searchCriteria === 'name' ||
      searchCriteria === 'id' ||
      searchCriteria === 'status'
    ) {
      setSearchId('')
      setSearchTerm('')
      setSearchName('')
      setSearchStatus('')
    }
  }

  useEffect(() => {
    if (searchCriteria === 'status') {
      setSearchStatus(`${`${searchTerm.toUpperCase().split(' ').join('')}`}`)
    } else if (searchCriteria === 'name') {
      setSearchName(`${searchTerm}`)
    } else if (searchCriteria === 'id') {
      setSearchId(`${searchTerm.toUpperCase().split(' ').join('')}`)
    } else {
      setSearchStatus('')
      setSearchName('')
      setSearchId('')
    }
  }, [searchTerm])

  useEffect(() => {
    setActivePage(0)
  }, [customer])

  setViewAlert(false)
  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    localStorage.getItem('customerTank') !== null &&
      localStorage.getItem('customerTank') !== '' &&
      !viewAlert &&
      handleSaveCustomerSelect(localStorage.getItem('customerTank'))
  }, [viewAlert])

  useEffect(() => {
    if (userEmail) {
      setActivePage(0)
      GetAllCustomers(userEmail, productName).then((data) => {
        console.log('Customer List', data)
        setCustomersList(data || [])
      })
    }
  }, [userEmail])

  const onDetailsClick = async (item) => {
    try {
      const assetData = await GetAllDeviceInfo(
        item['device id'],
        userEmail,
        productName,
      )
      setAssetData({
        ...assetData,
        customerId: customer,
        deviceId: item['device id'],
      })
      dispatch(setDeviceData(item))
      setViewAlert(true)
    } catch (e) {
      setDialogContent(
        <>
          <Icon name="exclamation triangle" size="huge" color="red" />
          <p style={{ fontSize: 'x-large' }}>{e.message}</p>
        </>,
      )
      setShowStatusDialog(true)
    }
  }

  const handleClear = () => {
    GetPaginationDevicesList(userEmail, productName, activePage, pageSize).then(
      (data) => {
        setAssetList(data.data)
        setNoOfPages(data['no of pages'])
      },
    )
  }

  useEffect(() => {
    if (userEmail) {
      if (
        // searchTerm.split(' ').join('') !== '' &&
        searchCriteria === 'id'
      ) {
        GetPaginationDevicesList(
          userEmail,
          productName,
          activePage,
          pageSize,
          null,
          null,
          searchTerm.split(' ').join('') === ''
            ? null
            : searchId.split(' ').join(''),
          customer,
        ).then((data) => {
          setAssetList(data.data)
          setNoOfPages(data['no of pages'])
          setSearchId(searchTerm.toLocaleUpperCase())
        })
      } else if (
        searchTerm.split(' ').join('') !== '' &&
        searchCriteria === 'name'
      ) {
        GetPaginationDevicesList(
          userEmail,
          productName,
          activePage,
          pageSize,
          null,
          searchTerm.split(' ').join('') === '' ? null : searchName,
          null,
          customer,
        ).then((data) => {
          setAssetList(data.data)
          setNoOfPages(data['no of pages'])
          setSearchName(searchTerm)
        })
      } else if (
        searchTerm.split(' ').join('') !== '' &&
        searchCriteria === 'status'
      ) {
        GetPaginationDevicesList(
          userEmail,
          productName,
          activePage,
          pageSize,
          searchTerm.split(' ').join('') === ''
            ? null
            : searchStatus.split(' ').join(''),
          null,
          null,
          customer,
        ).then((data) => {
          setAssetList(data.data)
          setNoOfPages(data['no of pages'])
          setSearchStatus(searchTerm)
        })
      }
    }
  }, [userEmail, activePage, searchName, searchId, customer])

  useEffect(() => {
    if (searchCriteria === 'status') {
      setSearchStatus(`${`${searchTerm.toUpperCase().split(' ').join('')}`}`)
    } else if (searchCriteria === 'name') {
      setSearchName(`${searchTerm}`)
    } else if (searchCriteria === 'id') {
      setSearchId(`${searchTerm.toUpperCase().split(' ').join('')}`)
    } else {
      setSearchStatus('')
      setSearchName('')
      setSearchId('')
    }
  }, [searchTerm])

  const onChange = (e, pageInfo) => {
    setActivePage(pageInfo.activePage - 1)
  }

  const handleStatusSelect = (e) => {
    setSearchTerm(e.target.outerText.toUpperCase())
    console.log(e.target.outerText.toUpperCase())
  }

  const handleCustomerSelect = (e) => {
    const [id, name, customeremail, tenant] = e.target.value.split(',')
    const customerDetails = {
      c_id: id,
      c_name: name,
      c_email: customeremail,
      c_tenant: tenant,
    }
    localStorage.setItem('customerTank', JSON.stringify(customerDetails))
    setCustomer(id)
    setSelectState(e.target.value)
    console.log(id, name)
    if (name !== 'none') {
      GetCustomerDevices(
        customeremail,
        localStorage.getItem('product'),
        activePage,
        pageSize,
        id,
      ).then((_data) => {
        setActivePage(0)
        setAssetList(_data.data)
        setNoOfPages(_data['no of pages'])
      })
    }
  }

  const filteringCriteria = function (prop) {
    if (searchCriteria === 'name') {
      if (prop['device label']) {
        return prop['device label']
          .toUpperCase()
          .includes(searchTerm.toUpperCase().split(' ').join(''))
      }
    } else if (searchCriteria === 'status') {
      if (prop['device status']) {
        return prop['device status']
          .toUpperCase()
          .includes(searchTerm.toUpperCase().split(' ').join(''))
      }
    }
    return prop['device name'] !== null
      ? prop['device name']
          .toLocaleLowerCase()
          .includes(searchTerm.toLocaleLowerCase().split(' ').join(''))
      : ''
  }

  const handleStatusStyle = (condition) => {
    if (condition === 'CONFIGURED') {
      return {
        color: 'blue',
      }
    }
    if (condition === 'OFFLINE') {
      return {
        color: 'red',
      }
    }
    if (condition === 'INSTALLED')
      return {
        color: 'green',
      }
    return {
      color: 'orange',
    }
  }

  const listItems = assetList ? (
    assetList
      .filter((item) => filteringCriteria(item))
      .map((item) => (
        <Table.Row key={item['device id']}>
          <Table.Cell>
            {item['device label'] === null ||
            item['device label'] === '' ||
            item['device label'] === 'null'
              ? item['device name']
              : item['device label']}
          </Table.Cell>
          <Table.Cell>{item['device name']}</Table.Cell>
          <Table.Cell style={handleStatusStyle(item['device status'])}>
            <b>
              <IntelMsg id={item['device status']} />
            </b>
          </Table.Cell>
          {getActions(() => onDetailsClick(item))}
        </Table.Row>
      ))
  ) : (
    <Table.Row>
      <Table.Cell colSpan="4">
        <p style={{ textAlign: 'center' }}>
          <strong>
            <IntelMsg id="thereIsNoDevicesToShow" />
          </strong>
        </p>
      </Table.Cell>
    </Table.Row>
  )
  const formSubmitter = (e) => {
    e.preventDefault()
  }

  return (
    <>
      <div>
        <Form onSubmit={formSubmitter}>
          <Form.Group className={styles.formm} inline widths="equals">
            <span className={styles.span}>Customer Name</span>
            <select
              value={selectState}
              onChange={handleCustomerSelect}
              style={{ width: 300, height: 40 }}
            >
              <option selected value="none,none">
                NONE
              </option>
              {customersList.map((item) => (
                <option
                  key={item.title}
                  value={`${item.tbCustomerId},${item.title},${item.email},${item.tenantId}`}
                >
                  {item.title}
                </option>
              ))}
            </select>
          </Form.Group>
          <br />
          <Form.Group className={styles.formm} inline widths="equals">
            <span className={styles.span}>Select Your Search Criteria </span>
            <Form.Input
              style={{ width: 200, height: 20 }}
              control={Form.Select}
              defaultValue="id"
              options={criteria}
              selection
              placeholder="Criteria"
              onChange={(e) => handleSelect(e)}
            />
            <Form.Input
              style={{ width: 200, height: 20 }}
              control={Form.Select}
              options={status}
              selection
              disabled={searchCriteria !== 'status'}
              placeholder="Status Selection"
              onChange={(e) => handleStatusSelect(e)}
            />
            <DebounceInput
              className={styles.sel}
              debounceTimeout={400}
              style={{ width: 600, height: 40 }}
              floated="right"
              label={{ icon: 'asterisk' }}
              labelPosition="right corner"
              type="text"
              placeholder="Search for a device with Dropdown Criteria"
              value={searchTerm}
              onChange={handleChange}
              disabled={searchCriteria === 'status'}
            />
            <Button
              primary
              onClick={() => {
                setSearchTerm('')
                handleClear()
                setSelectState('all,all')
              }}
              style={{ width: 94, height: 40 }}
              floated="right"
            >
              Clear
            </Button>
          </Form.Group>
          <br />
        </Form>
      </div>
      <div className={styles.container}>
        <IntelMsg id="devicesList" />
      </div>
      <Table sortable compact celled basic>
        <Table.Header style={{ backgroundColor: 'rgb(216, 231, 234)' }}>
          <Table.Row style={{ textAlign: 'center' }}>
            <Table.HeaderCell>
              <IntelMsg id="deviceName" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <IntelMsg id="deviceId" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <IntelMsg id="Status" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <IntelMsg id="actions" />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body
          style={{ textAlign: 'center' }}
          className={classes.tableBody}
        >
          {listItems}
        </Table.Body>
      </Table>
      <Table.Footer className={classes.footer} colSpan={2}>
        <Pagination
          floating="right"
          activePage={activePage + 1}
          onPageChange={(e, data) => onChange(e, data)}
          totalPages={noOfPages}
          firstItem={{
            content: <Icon name="angle double left" />,
            icon: true,
          }}
          lastItem={{
            content: <Icon name="angle double right" />,
            icon: true,
          }}
          prevItem={{ content: <Icon name="angle left" />, icon: true }}
          nextItem={{ content: <Icon name="angle right" />, icon: true }}
        />
      </Table.Footer>
      <div className={styles.actions}>
        <Button
          form="customerSettings"
          type="submit"
          style={{ backgroundColor: primaryColor, color: 'white' }}
          onClick={() => {
            if (productName === 'tank') history.push('/Tank')
            else history.push('/cold')
          }}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
      </div>
      <StatusDialog
        showDialog={showStatusDialog}
        setShowDialog={setShowStatusDialog}
        dialogHeader={<IntelMsg id="Asset" />}
        dialogContent={dialogContent}
      />
    </>
  )
}

const getActions = (deviceDetailsOnClick) => (
  <Table.Cell width={3}>
    <Button animated size="medium" onClick={deviceDetailsOnClick}>
      <Button.Content hidden>
        <IntelMsg id="Details" />
      </Button.Content>
      <Button.Content visible>
        <Icon name="ellipsis horizontal" />
      </Button.Content>
    </Button>
  </Table.Cell>
)

DeviceList.propTypes = {}

export default DeviceList
